import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css'

// Edge extensions sometimes call string methods on SVGAnimatedString.className.
// Add lightweight compatibility methods to avoid runtime TypeError in injected content scripts.
if (typeof SVGAnimatedString !== 'undefined') {
	for (const method of ['includes', 'indexOf', 'startsWith', 'endsWith', 'match'] as const) {
		const proto = SVGAnimatedString.prototype as unknown as Record<string, unknown>
		if (typeof proto[method] !== 'function') {
			proto[method] = function (...args: unknown[]) {
				const stringProto = String.prototype as unknown as Record<string, (...a: unknown[]) => unknown>
				return stringProto[method].apply((this as unknown as SVGAnimatedString).baseVal, args)
			}
		}
	}
}

/**
 * Punkt wejścia aplikacji Vue.
 * Inicjalizuje Pinia (stan), Vue Router (nawigacja) i montuje App.
 */
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

app.mount('#app')
